const ID_TOKEN_KEY = "id_token";
const REFRESH_TOKEN = "refresh_token";
const CUSTOMER_ID = "customer_id";
const LOCAL_CART = "local_cart";
const WEBHOOK_DATA = "webhook_data";

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};
export const getRefreshToken = () => {
  return window.localStorage.getItem(REFRESH_TOKEN);
};
export const getCustomerId = () => {
  return window.localStorage.getItem(CUSTOMER_ID);
};

export const saveToken = (token, refresh, id) => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
  window.localStorage.setItem(REFRESH_TOKEN, refresh);
  window.localStorage.setItem(CUSTOMER_ID, id);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN);
  window.localStorage.removeItem(CUSTOMER_ID);
};
export const getCartLocal = () => {
  return window.localStorage.getItem(LOCAL_CART);
};
export const setCartLocal = cart => {
  window.localStorage.setItem(LOCAL_CART, cart);
};
export const destroyCartLocal = () => {
  window.localStorage.removeItem(LOCAL_CART);
};
export const getWebhookData = () => {
  return window.localStorage.getItem(WEBHOOK_DATA);
};
export const setWebhookData = webhookData => {
  window.localStorage.setItem(WEBHOOK_DATA, webhookData);
};
export const destroyWebhookData = () => {
  window.localStorage.removeItem(WEBHOOK_DATA);
};

export default {
  getToken,
  getRefreshToken,
  getCustomerId,
  saveToken,
  destroyToken,
  getCartLocal,
  setCartLocal,
  destroyCartLocal,
  getWebhookData,
  setWebhookData,
  destroyWebhookData
};
